import React from 'react';

import SvgContainer from '../SvgContainer';

const Plus = () => {
    return (
        <SvgContainer>
            <g clipPath="url(#clip0_9085_100956)">
                <path d="M16 8C16 8.63118 15.4883 9.14286 14.8571 9.14286H9.14286V14.8571C9.14286 15.4883 8.63118 16 8 16C7.36882 16 6.85714 15.4883 6.85714 14.8571V9.14286H1.14286C0.511674 9.14286 0 8.63118 0 8C0 7.36882 0.511674 6.85714 1.14286 6.85714H6.85714V1.14286C6.85714 0.511674 7.36882 0 8 0C8.63118 0 9.14286 0.511674 9.14286 1.14286V6.85714H14.8571C15.4883 6.85714 16 7.36882 16 8Z" />
            </g>
            <defs>
                <clipPath id="clip0_9085_100956">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </SvgContainer>
    );
};

export default Plus;
